import { FormsModel } from '../models/forms.model';
import RequestCreator from './helpers/requestCreator';

class Form extends RequestCreator<FormsModel> {}

const api = new Form('/forms');
export default api;
